import { SurfaceDragDropState } from 'owa-calendar-surface-dategrid';

/**
 * Whether we are currently dragging an item on the specified surface
 * @param store The surface store
 * @return True if dragging, false otherwise
 */
export function isDragging(dragDropState: SurfaceDragDropState): boolean {
    return dragDropState.draggedItemModel != null;
}
